module.exports = __webpack_public_path__ + "static/media/logo-muvv.9c9fdbf5.svg";